import styled, { css } from "styled-components";
import { hexToRgba, rgbaToHex } from "../../../../sharable/PickerAndSelector";

export const FromXToYPromo = styled.span`
  ${({ canvasScale, styles }) => {
    const fontScale = styles.fontSize * canvasScale;
    const bgColorHex = hexToRgba(styles.secondaryBgColor, 1);
    const txtColorHex = hexToRgba(styles.secondaryTxtColor, 1);
    return css`
      width: min(100%, var(--main-price-width));
      max-width: var(--main-price-width);
      border-radius: ${16 * canvasScale}px;
      text-align: right;

      .wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
      }

      .normal-selling-price {
        padding: ${canvasScale * 2}px ${canvasScale * 4}px;
        font-size: ${fontScale * 0.8}px;
        font-weight: bold;
        display: inline-block;
        background-color: ${txtColorHex};
        color: ${bgColorHex};
        width: minmax(
          ${((Number(styles.fontSize) * 1.2) / 2) * 5 * canvasScale}px,
          var(--main-price-width)
        );
        height: min-content;
        position: relative;
        text-align: center;
        border-radius: ${8 * canvasScale}px;
      }

      .normal-selling-price::after {
        top: 50%;
        left: 0;
        transform: translateY(-50%) rotate(-15deg);
      }

      .normal-selling-price::after {
        content: "";
        position: absolute;
        width: 100%;
        height: ${canvasScale * 3}px;
        background-color: ${bgColorHex};
      }

      .de,
      .por {
        font-size: ${fontScale * 0.5}px;
        background-color: ${bgColorHex};
        color: ${txtColorHex};
        border-radius: ${8 * canvasScale}px;
        text-transform: uppercase;
        text-align: center;
        border-radius: ${10 * canvasScale}px;
        padding: ${canvasScale * 1}px;
        width: min(
          ${((Number(styles.fontSize) * 1.2) / 2) * 5 * canvasScale}px,
          var(--main-price-width)
        );
      }
    `;
  }}
`;
